import { createSelector } from '@ngrx/store';

import { selectFehHomebatteryState } from '../feh-homebattery.state';

export const selectHomebatteryAdviceFormState = createSelector(
  selectFehHomebatteryState,
  (state) => state['homebattery-advice-form']
);

export const selectHomebatteryAdviceSubmitState = createSelector(
  selectHomebatteryAdviceFormState,
  (state) => state.submitState
);

export const selectHomebatteryAdviceRedirectUrl = createSelector(
  selectHomebatteryAdviceFormState,
  (state) => state.redirectUrl
);
